import { render, staticRenderFns } from "./AdminPayerUpdate.vue?vue&type=template&id=6f940ba8&scoped=true"
import script from "./AdminPayerUpdate.vue?vue&type=script&lang=js"
export * from "./AdminPayerUpdate.vue?vue&type=script&lang=js"
import style0 from "./AdminPayerUpdate.vue?vue&type=style&index=0&id=6f940ba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f940ba8",
  null
  
)

export default component.exports